export default "__VITE_ASSET__Vkse36Fh__"